module.exports = __webpack_public_path__ + "img/kz.6a8a698f.svg";